import React from "react";
import Navbar from "../components/Navbar";
import DonateSection from "../components/DonateSection";
import Footer from "../components/Footer";
import { donationAPI } from "../services/postgresService";

const DonatePage = () => {
  const handleDonate = async (payload) => {
    return donationAPI.create(payload);
  };

  return (
    <div className="bg-gray-50 min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow">
        <DonateSection onSubmitDonation={handleDonate} />
      </div>
      <Footer />
    </div>
  );
};

export default DonatePage;